import { Component, OnInit, PLATFORM_ID, Inject, Output, EventEmitter } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../../shared/services/dashboard.service';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Output() public trackingResponse = new EventEmitter<any>();

  public action: string = '';

  public form: any = {
    driver_name: '',
    truck_number: '',
    device_id: ''
  };

  public devices: any[] = [];
  public devices_loading = false;
  public devices_error = '';
  public form_error = '';
  private modalRef: NgbModalRef | null = null;
  private rowToStop: any = null;

  constructor(private modalService: NgbModal,
    private dashboardService: DashboardService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadDevices();
    }
  }

  getBody() {
    let body: any = {
      action: this.action,
      account_id: localStorage.getItem('account')
    }

    if (this.action === "startFlowTracking") {
      body['user_id'] = localStorage.getItem('user');
      body['device_id'] = this.form.device_id;
      body['driver_name'] = this.form.driver_name;
      body['truck_number'] = this.form.truck_number;
    }

    return body;
  }

  private loadDevices() {
    this.devices_loading = true;
    this.action = 'getFlowTrackingDevices';
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      this.devices = Array.isArray(res.data) ? res.data : [];
      this.devices_loading = false;
    }, () => {
      this.devices_error = 'Could not load devices.';
      this.devices_loading = false;
    });
  }

  openAddModal(content: any) {
    this.resetForm();
    this.modalRef = this.modalService.open(content, {
      centered: true,
      ariaLabelledBy: 'flow-tracking-add-title'
    });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }

  resetForm() {
    this.form = {
      driver_name: '',
      truck_number: '',
      device_id: ''
    };
    this.form_error = '';
  }

  isFormValid() {
    const driver = (this.form.driver_name || '').trim();
    const truck = (this.form.truck_number || '').trim();

    return driver.length > 0 && truck.length > 0 && this.form.device_id !== '';
  }

  saveEntry() {
    if (!this.isFormValid()) {
      this.form_error = 'Please fill Driver name and Truck number, and select a device.';
      return;
    }

    this.action = 'startFlowTracking';
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      
      this.trackingResponse.emit(res);
      
    }, () => {
      this.form_error = 'Could not start tracking.';
    });

    if (this.modalRef) {
      this.modalRef.close();
    }
    this.resetForm();
  }

  startRow(row: any) {
    row.status = 'running';
  }

  openStopModal(content: any, row: any) {
    this.rowToStop = row;
    this.modalRef = this.modalService.open(content, {
      centered: true,
      ariaLabelledBy: 'flow-tracking-stop-title'
    });
  }

  confirmStop() {
    if (this.rowToStop) {
      this.rowToStop.status = 'stopped';
      this.rowToStop = null;
    }

    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  stopRow(row: any) {
    row.status = 'stopped';
  }
}
